module.exports = __webpack_public_path__ + "assets/img/101411.3d6b37dc.png";